<template>
  <div>
    <div class="routerChange">
      <el-button v-show="downloadExcelShow" class="lookUp" type="danger" @click="download" :disabled="picload" icon="el-icon-download">下载</el-button>
      <el-button v-show="!downloadExcelShow" class="lookUp" type="warning" :loading="true" plain>下载..</el-button>
      <el-button class="goBack" @click="goBack">返回</el-button>
      <div class="projectInfo">
        <div class="blockHeader">
          <div class="redBlock"></div>
          <div class="headerText">{{projectDayName}}</div>
        </div>
        <div class="blockContent">
          <div class="blockItem">
            <div class="item_type1">
              <div class="itemLeft">工程名称</div>
              <div class="itemRight">
                <span class="infoShow">{{projectObj.name}}</span>
              </div>
            </div>
            <div class="item_type1">
              <div class="itemLeft">工程地址</div>
              <div class="itemRight">
                <span class="infoShow">{{projectObj.address}}</span>
              </div>
            </div>
            <div class="item_type1">
              <div class="itemLeft">已关联标段</div>
              <div class="itemRight">
                <span class="infoShow">{{projectObj.sectionNames}}</span>
              </div>
            </div>
            <div class="item_type1">
              <div class="itemLeft">工程进度</div>
              <div class="itemRight">
                <span class="infoShow">{{projectObj.process}}%</span>
              </div>
            </div>
          </div>
          <div class="blockItem">
            <div class="item_type1">
              <div class="itemLeft">开始施工时间</div>
              <div class="itemRight">
                <span class="infoShow">{{projectObj.minTime}}</span>
                </div>
            </div>
            <div class="item_type1">
              <div class="itemLeft">最后施工时间</div>
              <div class="itemRight">
                <span class="infoShow">{{projectObj.maxTime}}</span>
              </div>
            </div>
            <div class="item_type1">
              <div class="itemLeft">开始施工桩号</div>
              <div class="itemRight">
                <span class="infoShow">{{workList[0].workType==3||workList[0].workType==4?projectObj.minPileNum:'--'}}</span>
              </div>
            </div>
            <div class="item_type1">
              <div class="itemLeft">结束施工桩号</div>
              <div class="itemRight">
                <span class="infoShow">{{workList[0].workType==3||workList[0].workType==4?projectObj.maxPileNum:'--'}}</span>
              </div>
            </div>
          </div>
          <div class="blockItem">
            <div class="item_type1">
              <div class="itemLeft">施工单位</div>
              <div class="itemRight">
                <span class="infoShow">{{projectObj.consUnit}}</span>
              </div>
            </div>
            <div class="item_type1">
              <div class="itemLeft">监理单位</div>
              <div class="itemRight">
                <span class="infoShow">{{projectObj.supervisor}}</span>
              </div>
            </div>
            <div class="item_type2" v-if="workList[0].workType==3||workList[0].workType==4">
              <div class="itemLeft">今日施工里程</div>
              <div class="itemRight">
                <span class="infoShow">
                  <span class="infoShow">{{projectObj.todayMileage==null?'--':projectObj.todayMileage}} km</span>
                </span>
              </div>
            </div>
            <div class="item_type2" v-if="workList[0].workType==1||workList[0].workType==2">
              <div class="itemLeft">今日施工面积</div>
              <div class="itemRight">
                <span class="infoShow">
                  <span class="infoShow">{{projectObj.todayArea==null?'--':projectObj.todayArea}} m²</span>
                </span>
              </div>
            </div>
          </div>
        </div>  
      </div>

      <div class="projectInfo" v-for="(item,index) in workList" :key="index">
        <reportWork :workInfo="item"></reportWork>
        <interventionEquip :workEquipList="item.equipList"></interventionEquip>
        <compaction :workInfo="item" :projectCheck="true"></compaction>
      </div>
    </div>
    
  </div>
</template>

<script>
  import{getDayReportInfo} from '../../utils/api'
  import reportWork from './report/reportWork'
  import interventionEquip from './report/interventionEquip'
  import compaction from './report/compaction'
  import { Loading } from 'element-ui';
  import axios from 'axios';
  import Cookies from 'js-cookie'
  import{getDateSeconds,dataURLtoFile} from '../../utils/commons'
  export default {
    name      : 'app',
    data() {
      return {
        arrowList: [
          {
            name: '工程中心',
            path: '/transfer/engineeringCenter'
          },
          {
            name: "工程进度",
            path: "/transfer/engineeringProgress",
          },
          {
              name: '每日日报',
              path: ''
          },
          {
              name: '',
              path: ''
          },
        ],
        projectName: '1号工程',
        projectObj: '',
        projectDayName: '',
        projectId:'',
        workList: '',
        loadingInstance: '',
        date:'',
        downloadExcelShow: true,
        picload:true
        // icv_legend: require('../../images/all/icvNum.png'),
        // rn_legend: require('../../images/all/rollNum.png'),
        // icv_l:'',
        // rn_l:'',
      }
    },
    computed:{

    },
    created(){
    },
    mounted(){
      this.$store.commit('setArrowList', this.arrowList)
      let params = this.$route.query
      // this.arrowList[2].name = '1号工程'
      this.date= params.date
      this.projectId=params.projectId
      console.log(params)
      this.loadingInstance = Loading.service({});
      let set = {
        date: params.date,
        projectId: params.projectId
      }
      getDayReportInfo(set).then((res)=>{
        console.log(res)
        if(res.data.code==500){
          // this.$message({
          //   message: res.data.message,
          //   type: 'warning'});
            setTimeout(()=>{
              this.$router.go(-1)
            },2000)
        }
        let getData = res.data.content.info
        this.arrowList[3].name = getData.projectInfo.name
        this.projectDayName = getData.projectInfo.date+getData.projectInfo.name + '工程日报'
        this.projectObj = getData.projectInfo
        this.workList = getData.workInfos
        this.loadingInstance.close();
        let timer=setInterval(()=>{
          if(this.$store.state.rn_view.length>=this.workList.length && this.$store.state.icv_view.length>=this.workList.length){
              this.picload=false
              clearInterval(timer)
            }
        },200)
      })
    },
    beforeDestroy(){
      this.loadingInstance.close();
    },
    methods: {
      async download(){
        this.downloadExcelShow = false
        this.loadingInstance = Loading.service({text:'下载中...'});
        let fileArr=[];
        // this.icv_l= new Image();
        // this.icv_l.src= this.icv_legend;
        // this.rn_l= new Image();
        // this.rn_l.src= this.rn_legend;
        // let icv_legend = await getBase64Image(this.icv_l);
        // console.log(icv_l,icv_l.src,icv_legend)
        // let rn_legend = await getBase64Image(this.rn_l);
        // console.log(rn_l,rn_l.src,rn_legend)
        for(let i=0;i<this.workList.length;i++){
          let workId=this.workList[i].id
          let icv_legend = this.$store.state.icv_exam[i];
          let rn_legend = this.$store.state.rn_exam[i];
          let rn='';
          this.$store.state.rn_view.map(item=>{
            if(item.workId==workId){
              rn=item.content
            }
          })
          let icv='';
          this.$store.state.icv_view.map(item=>{
            if(item.workId==workId){
              icv=item.content
            }
          })
          let tp='';
          this.$store.state.tp_view.map(item=>{
            if(item.workId==workId){
              tp=item.content
            }
          })
          console.log(icv_legend,rn_legend,rn,'icv_legend111')
          fileArr.push(dataURLtoFile(icv_legend.src,`w_${workId}_icv_legend`));
          fileArr.push(dataURLtoFile(rn_legend.src,`w_${workId}_rn_legend`));
          fileArr.push(dataURLtoFile(rn.src,`w_${workId}_rn_view`));
          fileArr.push(dataURLtoFile(icv.src,`w_${workId}_icv_view`));
          if(this.workList[i].workType==3||this.workList[i].workType==4){
            fileArr.push(dataURLtoFile(tp.src,`w_${workId}_tp_view`));
          }
        }
        
        const data=new FormData();
        fileArr.map((item)=>{
          data.append('files',item,item.name)
        })
        let config={
          headers:{'Content-Type':'multipart/form-data',token:Cookies.get('token'),Authorization:Cookies.get('token')},
          responseType: 'blob',
        }
        const InstructionManualvv = await axios.post(this.$store.state.baseUrl+'/construction/exportPdf/quantity/dayReport?date='+this.date+'&projectId='+this.projectId,data,config)
        if(InstructionManualvv.data.size < 80){
          this.$message({
              message: '下载失败',
              type: 'warning'
          });
          this.downloadExcelShow = true
          this.loadingInstance.close();
          return
        }
        if(InstructionManualvv.data.code){
          this.$message({
              message: InstructionManualvv.data.message,
              type: 'warning'
          });
          this.downloadExcelShow = true
          this.loadingInstance.close();
          return
        }else{
          this.$message({
              message: '下载成功',
              type: 'success'
          });
          this.downloadExcelShow = true
          this.loadingInstance.close();
        }
        let blob = new Blob([InstructionManualvv.data], {type: 'application/pdf;charset=UTF-8'});
        let fileName = this.projectDayName+getDateSeconds()+'.pdf';
        if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName)
        } else {
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href) //释放内存
        }
      },
      goBack: function(){
          this.$router.go(-1);
      },
    },
    components:{
      reportWork,
      interventionEquip,
      compaction
    }
  }
</script>

<style lang="scss" scoped="">
.projectInfo{
    width: 98.5%;
    height: auto;
    padding-bottom: 21px;
    margin: 0 auto;
    background-color: #ffffff;
    margin-bottom: 12px;
    .blockHeader{
      width: 100%;
      height: 58px;
      position: relative;
        .workListTable{
          width: 1200px;
          height: 38px;
          position: absolute;
          top: 15px;
          left: 130px;
          // background-color: aquamarine;
          overflow-x: auto;
          overflow-y: hidden;
          white-space: nowrap;
          
          .workItem {
            &.activeWorkItem {
              background-color: #e96b5a;
              .workItemText {
                color: #ffffff;
              }
            }
            color: #e96b5a;
            background: #fdf0ef;
            border-color: #f6c4bd;
            height: 32px;
            width: auto;
            display: inline-block;
            line-height: 30px;
            font-size: 14px;

            margin-right: 10px;
            margin-left: 10px;
            // padding: 0 30px;
            vertical-align: top;
            border: 1px solid #e96b5a;
            box-sizing: border-box;
            transform: skewX(-20deg);
            cursor: pointer;
            .workItemText {
              display: inline-block;
              height: 100%;
              width: 100%;
              padding: 0 30px;
              line-height: 30px;
              transform: skewX(20deg);
            }
          }
        }
        .redBlock{
          height: 18px;
          width: 4px;
          position: absolute;
          background-color: #E96B5A;
          top: 19px;
          left: 20px;
        }
        .headerText{
          height: 16px;
          line-height: 16px;
          color: #222222;
          display: inline-block;
          position: absolute;
          top: 21px;
          left: 34px;
          font-weight: 600;
        }

      .addBtn{
        position: absolute;
        top: 15px;
        right: 191px;
        border-radius:2px;
      }
      .deleteBtn{
        position: absolute;
        top: 15px;
        right: 15px;
        border-radius:2px;
      }
      .copyBtn{
        position: absolute;
        top: 15px;
        right: 133px;
        border-radius:2px;
      }
      .editBtn{
        position: absolute;
        top: 15px;
        right: 75px;
        border-radius:2px;
      }
    }
    .parameterContent{
        width: 97.7%;
        height: auto;
        margin: 0 auto;
    }
    .blockContent{
      width: 97.7%;
      margin: 0 auto;
      border-top:1px solid rgba(225, 225, 225, 1);
      border-left:1px solid rgba(225, 225, 225, 1);
      
      .blockItem{
        display: flex;
        height: 45px;
        .item_type1{
          flex: 1;
        }
        .item_type2{
          flex: 2;
        }
        .itemLeft{
          width: 120px;
          height: 44px;
          float: left;
          background:rgba(242,242,245,1);
          border-bottom:1px solid rgba(225, 225, 225, 1);
          border-right:1px solid rgba(225, 225, 225, 1);
          line-height: 44px;
          padding-left: 15px;
          color: #555555;
          font-size: 14px;
        }
        .itemRight{
          // width: 100%;
          height: 44px;
          line-height: 44px;
          padding-left: 18px;
          color: #555555;
          font-size: 14px;

          overflow: hidden;
          border-bottom:1px solid rgba(225, 225, 225, 1);
          border-right:1px solid rgba(225, 225, 225, 1);
          .infoShow{
            width: 100%;
            height: 100%;
            border: 0;
            color: #555555;
            font-size: 14px;
          }
        }
      }
    }
  }
.routerChange{
    width: 100%;
    margin-top: -57px;
    padding-top: 57px;
    position: relative;
    // margin-top: 57px;
    // min-height: 968px;
}
.lookUp{
    position: fixed;
    right: 75px;
    top: 65px;
    z-index: 1000;
  }
  .goBack{
    position: fixed;
    right: 16px;
    top: 65px;
    z-index: 1000;
  }
</style>